import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../../components/MessageBox/MessageBox";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
  },
  root: {
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
  button: {
    textAlign: "right",
    marginTop: "30px",
    "& .MuiButton-containedPrimary": {
      marginRight: "10px",
    },
  },

  buttonMarginRight: {
    marginRight: "0.5rem",
  },
}));

export default function AddSupplierModal(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [item, setItem] = useState("");
  const [itemQty, setItemQty] = useState("");
  const [qty, setQty] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);
  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");

  const handleOpen = () => {
    setOpen(true);
    setQty("");
  };

  const handleClose = () => {
    setOpen(false);
    setQty("");
  };
  const { supplierItem, addItem,setMaxQty } = props;

  const dummy_item_array = [
    { id: 1, itemname: "item1" },
    { id: 2, itemname: "item1" },
  ];

  const selectItemProps = {
    options: supplierItem,
    getOptionLabel: (option) =>
      option.itemname + (option.qty ? " (" + option.qty + ")" : ""),
  };

  const handleSubmit = (e) => {
    e.preventDefault();


    if (item.qty < qty) {
      handleClose();
      setShowMsgBox(true);
      setMsg("Quantity exceeds available stock.");
      setMsgType("error");
      setTimeout(() => {
        setShowMsgBox(false);
      }, 2500);
    } else {
      const newItem = {
        ...item,
        qty: parseInt(qty),
        maxQty: item.qty
      };
      addItem(newItem);
      handleClose();
    }
  };

  const ColorButton = withStyles(() => ({
    root: {
      color: "#fff",
      backgroundColor: "#4caf50",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#4caf50",
      },
    },
  }))(Button);

  useEffect(() => {
    if (item && qty != 0) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [item, qty]);
  return (
    <div>
      <Button
        style={{
          minWidth: "190px",
          marginBottom: "0.5em",
          marginRight: "0.5em",
        }}
        variant="outlined"
        color="primary"
        onClick={handleOpen}
      >
        Add Item Order
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2 id="transition-modal-title">Add Item</h2>
            <form onSubmit={handleSubmit} className={classes.root}>
              <Grid container spacing={3}>
                <Grid item xs={3}>
                  Item
                </Grid>
                <Grid item xs={9}>
                  <Autocomplete
                    {...selectItemProps}
                    id="auto-complete"
                    autoComplete
                    clearIcon={null}
                    includeInputInList
                    className={classes.autoComplete}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Item"
                        margin="normal"
                        variant="outlined"
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (!newValue) {
                        return;
                      } else {
                        if (
                          newValue &&
                          newValue.qty !== null &&
                          newValue.qty > 0
                        ) {
                          setItemQty(newValue);
                          setItem(newValue);
                        } else {
                          var balance = 0;

                          if (newValue.qty > 0) {
                            var balance = newValue.qty;
                          }
                          setItem(null);
                          setShowMsgBox(true);
                          setMsg(
                            "Insufficient inventory quantity. (Remaining:" +
                              balance +
                              ")"
                          );
                          setMsgType("error");
                          setTimeout(() => {
                            setShowMsgBox(false);
                          }, 2500);
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  Quantity
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    required
                    id="outlined-required"
                    label="Quantity"
                    variant="outlined"
                    type="number"
                    value={qty}
                    InputProps={{ inputProps: { min: 0 } }}
                    onKeyPress={(e) => {
                      if (e.key == "-") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      setQty(e.target.value);
                    }}
                    onBlur={(e) => {
                      if (parseFloat(e.target.value) > 0) {
                        setQty(e.target.value);
                      } else {
                        setQty(0);
                      }
                    }}
                  />
                </Grid>
              </Grid>
              <div className={classes.button}>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  className={classes.buttonMarginRight}
                >
                  Close
                </Button>
                <ColorButton
                  disabled={btnDisabled}
                  type="submit"
                  variant="contained"
                  color="primary"
                  classes={{
                    root: classes.root,
                    disabled: classes.disabled,
                  }}
                >
                  Add Inventory
                </ColorButton>
              </div>
            </form>
          </div>
        </Fade>
      </Modal>
      <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
    </div>
  );
}
